import { render, staticRenderFns } from "./SkeletonNews.vue?vue&type=template&id=9b61f13c&scoped=true&"
import script from "./SkeletonNews.vue?vue&type=script&lang=js&"
export * from "./SkeletonNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b61f13c",
  null
  
)

export default component.exports